/**
 * B2B catalogs hide product Compare-at in Liquid even when Admin has it set.
 * When RRP is missing, fetch the public product JSON (no session cookies) to
 * read the retail compare_at_price and fill RRP + margin on every .wl-price.
 */
(function () {
  if (window.__wlPriceInit) return;
  window.__wlPriceInit = true;

  var cache = {};
  var moneyFormat =
    (window.themeGlobalVariables &&
      window.themeGlobalVariables.settings &&
      window.themeGlobalVariables.settings.money_format) ||
    (window.cartStrings && window.cartStrings.money_format) ||
    (window.theme && window.theme.moneyFormat) ||
    '${{amount}}';

  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = format || moneyFormat;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    var value = (cents / 100).toFixed(2);
    var withComma = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(format)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('product js ' + res.status);
        return res.json();
      })
      .catch(function () {
        cache[handle] = null;
        return null;
      });
    return cache[handle];
  }

  function rrpFromProduct(data, variantId) {
    if (!data || !data.variants || !data.variants.length) return 0;
    var vid = variantId ? String(variantId) : '';
    var match = null;
    if (vid) {
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === vid) {
          match = data.variants[i];
          break;
        }
      }
    }
    if (!match) match = data.variants[0];
    var rrp = Number(match.compare_at_price) || 0;
    if (!rrp && data.compare_at_price) rrp = Number(data.compare_at_price) || 0;
    return rrp;
  }

  function applyRrp(el, rrpCents) {
    var price = Number(el.getAttribute('data-wl-price')) || 0;
    if (!rrpCents || rrpCents <= price) return;

    el.setAttribute('data-wl-rrp', String(rrpCents));
    el.removeAttribute('data-wl-needs-rrp');

    var format = el.getAttribute('data-money-format') || moneyFormat;
    var row = el.querySelector('.wl-price__row');
    if (!row) return;

    var rrpEl = el.querySelector('.wl-price__rrp');
    if (!rrpEl) {
      rrpEl = document.createElement('span');
      rrpEl.className = 'wl-price__rrp';
      row.appendChild(rrpEl);
    }
    rrpEl.textContent = 'RRP ' + formatMoney(rrpCents, format);

    var margin = Math.round(((rrpCents - price) * 100) / rrpCents);
    var marginEl = el.querySelector('.wl-price__margin');
    if (!marginEl) {
      marginEl = document.createElement('span');
      marginEl.className = 'wl-price__margin';
      el.appendChild(marginEl);
    }
    marginEl.textContent = margin + '% margin';
  }

  function hydrate(root) {
    var nodes = (root || document).querySelectorAll(
      '.wl-price[data-wl-needs-rrp="1"][data-product-handle]'
    );
    if (!nodes.length) return;

    var byHandle = {};
    Array.prototype.forEach.call(nodes, function (el) {
      var handle = el.getAttribute('data-product-handle');
      if (!handle) return;
      if (!byHandle[handle]) byHandle[handle] = [];
      byHandle[handle].push(el);
    });

    Object.keys(byHandle).forEach(function (handle) {
      fetchProduct(handle).then(function (data) {
        if (!data) return;
        byHandle[handle].forEach(function (el) {
          var rrp = rrpFromProduct(data, el.getAttribute('data-variant-id'));
          applyRrp(el, rrp);
        });
      });
    });
  }

  function boot() {
    hydrate(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    hydrate(e.target);
  });

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('.wl-price[data-wl-needs-rrp="1"]')) {
          hydrate(n.parentNode || document);
          return;
        }
        if (n.querySelector && n.querySelector('.wl-price[data-wl-needs-rrp="1"]')) {
          hydrate(n);
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
